import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import { submitTransferForm } from "../../actions/studensts";

const initialData = {
  national_id: "",
  student_phone: "",
  father_phone: "",
  mother_phone: "",
};

const Field = ({ label, name, value, onChange, type = "text", placeholder }) => (
  <div className="mb-5">
    <label className="block text-sm font-semibold text-gray-700 mb-1">
      <span className="text-red-500">*</span> {label}
    </label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      required
      placeholder={placeholder}
      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
        transition placeholder-gray-400"
    />
  </div>
);

export default function TransferForm() {
  const [formData, setFormData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await submitTransferForm(formData);
      setLoading(false);
      if (res === 201) {
        navigate("/transfer/success");
      } else {
        navigate("/transfer/error");
      }
    } catch {
      setLoading(false);
      navigate("/transfer/error");
    }
  };

  if (loading) return <Loading />;

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-10"
      style={{
        background: "linear-gradient(135deg, #1e3a5f 0%, #2e6da4 50%, #4a90d9 100%)",
      }}
    >
      <div className="w-full max-w-md">
        {/* Card */}
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Top accent bar */}
          <div className="h-2 bg-gradient-to-r from-blue-700 via-blue-500 to-blue-400" />

          <div className="px-8 pt-8 pb-10">
            {/* Title */}
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-blue-100 mb-4">
                <svg className="w-7 h-7 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                </svg>
              </div>
              <h1 className="text-2xl font-bold text-gray-900">Transfer Request</h1>
              <p className="text-sm text-gray-500 mt-1">
                Private → Public University Transfer
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <Field
                label="National ID / Passport Number"
                name="national_id"
                value={formData.national_id}
                onChange={handleChange}
                placeholder="Enter your National ID or Passport No."
              />
              <Field
                label="Student Phone Number"
                name="student_phone"
                type="tel"
                value={formData.student_phone}
                onChange={handleChange}
                placeholder="e.g. 01012345678"
              />
              <Field
                label="Father Phone Number"
                name="father_phone"
                type="tel"
                value={formData.father_phone}
                onChange={handleChange}
                placeholder="e.g. 01012345678"
              />
              <Field
                label="Mother Phone Number"
                name="mother_phone"
                type="tel"
                value={formData.mother_phone}
                onChange={handleChange}
                placeholder="e.g. 01012345678"
              />

              <p className="text-xs text-gray-400 text-center mb-6">
                All fields marked <span className="text-red-500 font-bold">*</span> are required.
              </p>

              <button
                type="submit"
                className="w-full py-3 rounded-lg font-semibold text-white text-sm tracking-wide
                  bg-gradient-to-r from-blue-700 to-blue-500 hover:from-blue-800 hover:to-blue-600
                  transition-all shadow-md hover:shadow-lg active:scale-95"
              >
                Submit Transfer Request
              </button>
            </form>
          </div>
        </div>

        <p className="text-center text-xs text-blue-200 mt-6">
          American Academy &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
